module.exports = __webpack_public_path__ + "static/media/dashboard.1ba0e5e5.svg";